// import Link from "next/link";
import { FaqLinkTag } from './styles'

const Hyperlink = ({ uri, children }) => {
  if (uri.includes('https://') || uri.includes('www.')) {
    return (
      <FaqLinkTag
        href={uri}
        aria-label={uri.includes('acko.com') || uri.includes('ackodrive.com') ? 'internal-link' : 'external-link'}
        // rel="nofollow noreferrer noopener"
        rel={uri.includes('acko.com') || uri.includes('ackodrive.com') ? '' : 'noreferrer noopener nofollow'}
        target="_blank">
        {children}
      </FaqLinkTag>
    )
  } else {
    return <FaqLinkTag href={uri}>{children}</FaqLinkTag>
  }
}

export default Hyperlink
